import React from 'react'
import Typography from 'material-ui/Typography'
import TimeAgo from 'tlvince-react-timeago'

import Card, { CardContent } from 'material-ui/Card'

import StopList from './StopList'
import { withStyles } from 'material-ui/styles'
import CheckCircle from 'material-ui-icons/CheckCircle'
import PersonPin from 'material-ui-icons/PersonPin'
import Grid from 'material-ui/Grid'
import Avatar from 'material-ui/Avatar'
import colors from '../helpers/colors'
import IconButton from 'material-ui/IconButton'
import Edit from 'material-ui-icons/Edit'
import { Link } from 'react-router-dom'
import Button from 'material-ui/Button'

const Job = ({ job, stops, driver = {}, invoices = [], classes, handleAssign, openManifest }) => {
  let statusColor
  switch (job.status) {
    case 'done':
      statusColor = classes.statusColorDone
      break
    case 'accepted':
      statusColor = classes.statusColorStarted
      break
    default:
      statusColor = classes.statusColorNotDone
      break
  }

  const driverName =
    job.status !== 'unassigned' && driver ? driver.fullName : 'Unassigned'
  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container>
          <Grid item xs={12} sm={3} md={2} container direction='column'>
            <Avatar className={classes.avatar}>
              <PersonPin />
            </Avatar>
            <Typography type='subheading' align='center'>
              {driverName}
              <IconButton onClick={() => handleAssign(job._id)}>
                <Edit />
              </IconButton>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={9} md={10}>
            <Typography type='headline' component='h2' title={job._id}>
              {`Job ${job.title} `} <CheckCircle className={statusColor} />
            </Typography>
            <Typography component='h3'>
              Created <TimeAgo date={job.createdAt} />
            </Typography>
            {job.status !== 'unassigned' &&
              driver.lastOnlineAt && (
                <Typography>
                  Last online <TimeAgo date={driver.lastOnlineAt} />
                </Typography>
              )}

            {invoices.length > 0 &&
            <Typography>
              <Link to={`/job/${encodeURIComponent(job._id)}/invoices`}><Button>View Invoices</Button></Link>
            </Typography>
            }
            <StopList stops={stops} openManifest={openManifest} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

const styles = () => ({
  root: {
    marginBottom: '10px'
  },
  statusColorDone: colors.statusColorDone,
  statusColorNotDone: colors.statusColorNotDone,
  statusColorStarted: colors.statusColorStarted,
  avatar: {
    margin: '20px auto',
    width: 60,
    height: 60
  }
})
export default withStyles(styles)(Job)



// WEBPACK FOOTER //
// ./src/jobs/Job.js